module.exports = __webpack_public_path__ + "static/media/ImporterFeatureIcon2.2d15a5d0.svg";